import { Injectable } from '@angular/core';
import { HttpService } from './helpers/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from './helpers/error.service';

import { Dictionary, Settings } from '../models/models';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService {
  constructor(private httpService: HttpService, private errorService: ErrorService) {}

  getOrganizations(manualLoaderControl: boolean = false): Observable<Dictionary[]> {
    return this.httpService.sendGet('dictionary/organizations', manualLoaderControl).pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }

  getStatuses(): Observable<Dictionary[]> {
    return this.httpService.sendGet('dictionary/statuses').pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }

  getOfferKinds(manualLoaderControl: boolean = false): Observable<Dictionary[]> {
    return this.httpService.sendGet('dictionary/offerKinds', manualLoaderControl).pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }

  getOfferClassificators(): Observable<Dictionary[]> {
    return this.httpService.sendGet('dictionary/offerClassificators').pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }

  getAddOfferDictionaries(userId, manualLoaderControl: boolean = false): Observable<Dictionary[][]> {
    return this.httpService.sendGet('dictionary/add-offer-dictionaries?userId=' + userId, manualLoaderControl).pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }

  getSettings(): Observable<Settings> {
    return this.httpService.sendGet('dictionary/settings').pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }

  getAvailableStatuses(statusId: number, routeId: number = 0): Observable<Dictionary[]> {
    return this.httpService.sendGet(`dictionary/available-statuses?statusId=${statusId}&routeId=${routeId}`).pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }
}
